import Button from "../../common/Button";
import { PartWithInventory } from "../../../utils/hooks/inventory/boardInventory";
import useUpdateRequiredAmountForProject from "../../../utils/hooks/inventory/updateRequiredAmountForProject";

export default function ApproveAllocationButton({
  part,
  refreshing,
}: {
  part: PartWithInventory;
  refreshing?: boolean;
}) {
  const { updateQuantity, loading } = useUpdateRequiredAmountForProject();
  return part.num_elements_per_shipment <= part.amount_allocated &&
    part.amount_allocated < part.required_amount ? (
    <Button
      label={"Approve allocation"}
      isSmallSize
      onClick={
        loading
          ? undefined
          : () => void updateQuantity(part.part.id, part.amount_allocated)
      }
      disabled={loading || refreshing}
    />
  ) : null;
}
